import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import ErrorBoundary from "components/Library/ErrorBoundary";
import { MicrodataContext } from "config/contexts";

import styles from "./CardWrapper.css";

export default function CardWrapper(props) {
  return (
    <ErrorBoundary>
      <MicrodataContext.Consumer>
        {(microdata) => (
          <div
            className={classNames(styles.root, props.className)}
            itemScope={microdata}
            itemType={microdata ? "http://schema.org/NewsArticle" : undefined}
          >
            {props.children}
          </div>
        )}
      </MicrodataContext.Consumer>
    </ErrorBoundary>
  );
}

CardWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
